import { render } from "./petunjuk-soal-menjodohkan.vue?vue&type=template&id=ab10d6e0&scoped=true"
import script from "./petunjuk-soal-menjodohkan.vue?vue&type=script&lang=js"
export * from "./petunjuk-soal-menjodohkan.vue?vue&type=script&lang=js"

import "./petunjuk-soal-menjodohkan.vue?vue&type=style&index=0&id=ab10d6e0&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab10d6e0"]])

export default __exports__